import React from 'react'
import './../styles/index.css'


const Link = (props) => (
  <a className="link" {...props}>{props.children}</a>
);

export default Link


// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/Carousel/components/Link.js